import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { blue, orange } from "@mui/material/colors";
import type { FC } from "react";
import { formatDate } from "../data/dataUtils";
import type { ECommerceOfferProductWithNames } from "./eCommerceTypes";

interface Props {
  readonly products: Pick<ECommerceOfferProductWithNames, "name" | "date" | "providerName" | "options">[];
}

const OfferCardProducts: FC<Props> = ({ products }) => (
  <Table className="offer-card-products">
    <TableBody>
      {products.map((p, idx) => (
        <TableRow className="row" key={idx} style={{ height: "auto" }}>
          <TableCell>{formatDate(p.date)}</TableCell>
          <TableCell style={{ color: blue["600"] }}>{p.providerName}</TableCell>
          <TableCell style={{ color: orange["900"] }}>{p.name}</TableCell>
          <TableCell>{p.options.map((o) => `${o.name} ${o.quantity} szt.`).join(", ")}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default OfferCardProducts;
